// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 60,
  H_DESKTOP_OFFSET: 60 - 6,
};

export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 88,
};
